import Phaser from 'phaser';

// Scanlines + chromatic aberration + a touch of pixelation/vignette, applied
// as a camera post pipeline. WebGL-only (see Game.js — falls back to no fx
// on the Canvas renderer, consistent with the "auto-render" tech choice).
const fragShader = `
precision mediump float;
uniform sampler2D uMainSampler;
uniform float uTime;
uniform vec2 uResolution;
uniform float uAberration;
uniform float uScanlineIntensity;
uniform float uPixelSize;
varying vec2 outTexCoord;

void main() {
  vec2 uv = outTexCoord;

  if (uPixelSize > 1.0) {
    vec2 texel = uPixelSize / uResolution;
    uv = floor(uv / texel) * texel + texel * 0.5;
  }

  vec2 dir = uv - 0.5;
  vec4 colR = texture2D(uMainSampler, uv - dir * uAberration);
  vec4 colG = texture2D(uMainSampler, uv);
  vec4 colB = texture2D(uMainSampler, uv + dir * uAberration);
  vec4 color = vec4(colR.r, colG.g, colB.b, colG.a);

  float scan = sin(uv.y * uResolution.y * 1.4 + uTime * 2.0) * 0.5 + 0.5;
  color.rgb -= scan * uScanlineIntensity;

  float vig = smoothstep(0.95, 0.3, length(uv - 0.5));
  color.rgb *= mix(0.88, 1.0, vig);

  gl_FragColor = color;
}
`;

export class RetroPostFxPipeline extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline {
  constructor(game) {
    super({ game, fragShader });
    this.aberration = 0.0022;
    this.scanlineIntensity = 0.045;
    this.pixelSize = 1.0;
  }

  onPreRender() {
    this.set1f('uTime', this.game.loop.time / 1000);
    this.set2f('uResolution', this.renderer.width, this.renderer.height);
    this.set1f('uAberration', this.aberration);
    this.set1f('uScanlineIntensity', this.scanlineIntensity);
    this.set1f('uPixelSize', this.pixelSize);
  }
}
